<template>
  <div class="detail-notice">
    <Content
    item="公告">
    </Content>
    <div class="detail-content">
        <h1>{{totalTitle}}</h1>
        <section v-for="(item, index) in items" :key="index">
            <h2 v-if="item.title">{{item.title}}</h2>
            <p v-for="(para, paraIndex) in item.paragraphs" :key="paraIndex">{{para}}</p>
        </section>
    </div>
  </div>
</template>

<script>
import Content from "@/components/Content"
export default {
components: {
    Content
},
data(){
    return {
        totalTitle: "中国地质大学（武汉）地理与信息工程学院生态坏境大数据团队博士后招聘启事",
        items: [
            {
                title: "",
                paragraphs: [
                    "中国地质大学（武汉）是教育部直属全国重点大学, 是国家批准设立研究生院的大学，是国家“211工程”、国家“双一流”建设高校。学校现有教职员工3220余人，其中教师1870余人。中国科学院院士11人，博士生导师310人，教授520人，副教授927人。国家“万人计划”入选者13人（领军人才9人、青年拔尖人才4人），“长江学者奖励计划”入选者19人，国家杰出青年科学基金获得者16人，国家优秀青年科学基金获得者19人，教育部“新世纪优秀人才”入选者29人。学校拥有国家自然科学基金委创新研究群体3个，教育部创新团队3个，国家级教学团队6个，国家级教学名师2人，湖北省教学名师9人。",
                    "学校现有2个国家一级重点学科，16个湖北省重点学科；现有23个学院（所）、65个本科专业；有16个一级学科博士点，34个一级学科硕士点。学校现有各类科研机构、实验室、研究院（所、中心）86个，其中国家重点实验室2个，国家工程技术研究中心1个，科技部地质工程国际科技合作基地1个，科技部创新人才培养示范基地1个，省部级科研平台17个。",
                    "中国地质大学（武汉）地理与信息工程学院生态环 境大数据团队主要从事自然灾害的专业监测、气象预警、应急管理、应急指挥、防汛抗旱、水资源管理、生态环境大数据分析等科研工作。团队已先后承担全国地质灾害气象预警系统、地质灾害气象预警四级互联子系统（国家、省、市、县四级互联）等防灾减灾相关科研项目100多项，研究项目获得过国土资源科学技术奖、中国地理信息产业优秀工程奖、卫星导航定位科技进步奖等重大奖项。其中，在中央电视台发布的全国地质灾害气象预警预报是由该团队提供技术支撑。",
                    "为促进学科发展，凝聚高层次创新型优秀人才，推进构建国家级“生态环境+智慧应急”大数据及应用服务中心进程，中国地质大学（武汉）地理与信息工程学院生态环境大数据团队现公开招聘博士后研究人员。"
                ]
            },
            {
                title: "一、研究方向",
                paragraphs: [
                    "生态环境大数据、地质灾害动态预警与人工智能、智慧水利、智慧城市与云计算等"
                ]
            },
            {
                title: "二、招收条件",
                paragraphs: [
                    "1. 政治立场坚定，热爱祖国，拥护党的路线、方针、政策；热爱党的教育事业，品行端正、身心健康、吃苦耐劳、踏实认真、责任心强，具有良好的学术道德和严谨的科学态度，对科研工作兴趣浓厚，善于思考，积极进取，学风严谨，有责任心，身体健康；",
                    "2. 近三年内获得博士学位或应届博士研究生，已有高水平研究成果，年龄不超过35周岁；",
                    "3. 具有测绘科学与技术、水文地质学、环境科学等相近或相关学术与专业背景；",
                    "4. 具有较强的分析问题和解决问题的能力、文字表达和论文写作能力及团队协作能力；",
                    "5. 在站期间，需结合团队研究方向发表SCI学术论文2篇及以上；",
                    "6. 必须具备脱产在我校从事博士后研究工作的条件。"
                ]
            },
            {
                title: "三、应聘方式",
                paragraphs: [
                    "有意应聘者，请准备如下材料并按顺序合并为一个PDF文档，发送至罗显刚教授邮箱billlxg@126.com（邮件主题和PDF文件命名为“姓名+应聘博士后”）。",
                    "1. 个人申请信（简要说明自己的申请方向及研究计划、教育背景、研究经验及资历等）；",
                    "2. 个人详细简历；",
                    "3. 提供发表论文清单，博士学位论文摘要和1-3篇代表性论文扫描件，以及其它可以证明本人能力和学术水平的相关资料，博士学位导师的联系方式(电话和电子邮箱)；",
                    "4. 学术研究代表成果扫描件（专著需提供专著封面和目录，科研项目需提供项目批件，获奖或专利需提供证书）。",
                    "5. 博士毕业证和学位证（如无法提供，请提供答辩通过证明材料）；"
                ]
            },
            {
                title: "四、面试",
                paragraphs: [
                    "1. 初选合格者将通过Email或者电话方式进行初步沟通，并通知本人提供2封专家推荐信（要求其中1封为博士生导师提供）；",
                    "2. 通知本人参加面试；"
                ]
            },
            {
                title: "五、截止日期",
                paragraphs: [
                    "招聘到合适人员为止（2021年5月14日开始）"
                ]
            },
            {
                title: "六、相关待遇",
                paragraphs: [
                    "1. 提供科研条件和经费，鼓励并协助研究人员撰写高水平科技论文、结合团队研究方向申报国家自然科学基金和中国博士后科学基金等科研项目；",
                    "2. 工资及福利待遇按国家博士后相关规定和中国地质大学（武汉）博士后工资福利待遇有关规定执行；另团队也会给予一定的福利，具体待遇面谈；",
                    "3. 博士后出站后，由合作导师推荐央企或国企工作；特别优秀的博士后，合作导师向相关高校推荐留校任教。"
                ]
            },
            {
                title: "七、合作导师及联系方式",
                paragraphs: [
                    "罗显刚 billlxg@126.com",
                    "地址：湖北省武汉市洪山区锦程街68号 中国地质大学（武汉）未来城校区地理与信息工程学院"
                ]
            }
        ],
    }
}
}
</script>

<style scoped lang="less">
.detail-notice{
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.detail-content{
    width: 60%;
    margin: 50px 20%;
    h1{
        text-align: center;
        margin: 15px 0 50px 0;
    }
    h2{
        margin: 15px 0;
    }
    p{
        white-space: pre-line;
        text-indent: 2em;
        line-height: 1.8em;
    }
}
</style>